<template>
  <div class="payment-view">
    <div class="table-responsive">
      <table class="payment-table table table-striped first-td-padding">
        <thead>
          <tr class="d-flex">
            <td class="col-2 filters-page__table-heading">{{ $t('general.date') }}</td>
            <!-- <td class="col-4 filters-page__table-heading">{{ $t('payment.key') }}</td> -->
            <td class="col-3 filters-page__table-heading">{{ $t('payment.paymentType') }}</td>
            <td align="right" class="col-2 filters-page__table-heading">{{ $t('payment.amout') }}</td>
            <td class="col-1"></td>
            <td class="col-2 filters-page__table-heading">{{ $t('payment.invoice') }}</td>
          </tr>
        </thead>
        <tbody>
          <tr class="d-flex payment-info-row" v-for="item in payments" v-bind:key="item.id">
            <td class="col-2">{{ item.date }}</td>
            <!-- <td class="col-4 ellipsis">
              <vuestic-tooltip :options="{content: item.key, placement: 'bottom'}"><span>{{item.key}}</span></vuestic-tooltip>
            </td>-->
            <td class="col-3">{{ getPaymentType(item.paymentType) }}</td>
            <td class="col-2" align="right">{{ toCurrency(item.amount) }}</td>
            <td class="text-center col-1">
              <div class="xs3 md1 icon-grid-container">
                <div class="vuestic-icon vuestic-icon-set">
                  <span
                    @click="prefillForEdit(item)"
                    aria-hidden="true"
                    class="edit-icon glyphicon"
                    style="font-size: 16px;"
                  ></span>
                </div>
              </div>
            </td>
            <td class="text-center col-2">
              <div class="xs3 md1 icon-grid-container">
                <div class="vuestic-icon vuestic-icon-set">
                  <span
                    @click="generateInvoice(item)"
                    aria-hidden="true"
                    class="invoice-icon glyphicon"
                    style="font-size: 16px;"
                  ></span>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="d-flex">
            <td class="col-3"></td>
            <td align="right" class="col-4"></td>
            <td
              align="right"
              class="col-4 total-border"
              style="color:red"
            >{{ `${$t('payment.left')}: ${amountLeft}`}}</td>
            <td class="col-1 total-border"></td>
          </tr>
          <tr class="d-flex closer">
            <td class="col-3"></td>
            <td align="right" class="col-4"></td>
            <td align="right" class="col-4">
              <span>{{ `${$t('payment.totalPrice')}:`}}</span>
              {{ toCurrency(tripPrice)}}
            </td>
            <td class="col-1"></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="va-row add-row">
      <div class="col-md-3">
        <div class="form-group">
          <div class="input-group">
            <vuestic-date-picker
              :class="{'disabled':isEditing}"
              :disabled="isEditing"
              id="payment-date"
              :config="paymentDateConfig"
              v-model="date"
            />
            <label class="control-label" for="payment-date">{{ $t('general.date') }}</label>
            <i class="bar"></i>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <vuestic-simple-select
          :label="$t('payment.paymentType')"
          v-model="paymentType"
          name="paymentType"
          ref="paymentType"
          option-key="name"
          :options="paymentTypes"
        ></vuestic-simple-select>
      </div>
      <div class="col-md-3">
        <div class="form-group with-icon-right">
          <div class="input-group">
            <input v-model="amount" id="amount" autocomplete="off" v-on:keyup.enter="saveChanges" />
            <label
              class="control-label placeholder-label"
              for="amount"
              role="button"
            >{{$t('payment.amout')}}</label>
            <i class="bar"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="va-row">
      <div class="flex md6 offset--md3 text-center">
        <button type="button" class="btn btn-micro btn-primary" @click="saveChanges">
          <span aria-hidden="true" class="fa fa-plus" style="font-size: 16px;"></span>
          {{ $t(`payment.${isEditing ? "edit" : "add"}`) }}
        </button>
      </div>
    </div>
    <div v-if="isLoading" class="spinner center">
      <div class="spinner-box">
        <div data-v-2767e9c3 class="orbit-spinner" style="height: 80px; width: 80px;">
          <div
            data-v-2767e9c3
            class="orbit one"
            style="border-color: rgb(74, 227, 135); animation-duration: 1500ms;"
          ></div>
          <div
            data-v-2767e9c3
            class="orbit two"
            style="border-color: rgb(74, 227, 135); animation-duration: 1500ms;"
          ></div>
          <div
            data-v-2767e9c3
            class="orbit three"
            style="border-color: rgb(74, 227, 135); animation-duration: 1500ms;"
          ></div>
        </div>
      </div>
    </div>

    <!-- modeal -->
    <vuestic-modal
      :noButtons="true"
      v-bind:force="true"
      ref="invoiceNumberModal"
      :cancelClass="'none'"
    >
      <div
        slot="title"
      >{{ $t('payment.invoiceHeader', {date:this.invoiceDate, value:this.invoiceAmount})}}</div>
      <div> 
        <div class="col-md-5">
        <div class="form-group with-icon-right">
          <div class="input-group">
            <input v-model="invoiceNumber" id="invoiceNumber" autocomplete="off" />
            <label
              class="control-label placeholder-label"
              for="amount"
              role="button"
            >{{$t('payment.invoiceNumber')}}</label>
            <i class="bar"></i>
          </div>
        </div>
        </div>
        <button type="button" class="btn btn-micro btn-primary" @click="this.generateInvoiceFile">
          <span aria-hidden="true" class="fa fa-download" style="font-size: 16px;"></span>
          {{ $t(`payment.save`) }}
        </button>
        <button type="button" class="btn btn-micro btn-primary" @click="this.generateCreditPaymentFile">
          <span aria-hidden="true" class="fa fa-download" style="font-size: 16px;"></span>
          {{ $t(`payment.saveCredit`) }}
        </button>
      </div>
    </vuestic-modal>
  </div>
</template>

<script>
import { paymentApi } from "../../services/api/paymentApi";
import moment from "moment";
import { dateLocale, formatCurrency } from "../../utils";

export default {
  name: "payment",
  props: {
    tripId: Number,
    participantId: Number,
    tripPrice: Number
  },
  async created() {
    this.isLoading = true;
    return this.getAllPayments();
  },

  computed: {
    saveChanges() {
      if (!this.isValidInfo()) return () => {};
      return this.isEditing ? this.editPayment : this.addPayment;
    },
    amountLeft() {
      let left =
        this.tripPrice - this.payments.reduce((sum, p) => sum + p.amount, 0);
      if (left < 0) return formatCurrency(0, this.$i18n.locale());
      return formatCurrency(left, this.$i18n.locale());
    },
   
  },

  data() {
    return {
      paymentId: null,
      payments: [],
      date: moment().format(dateLocale),
      isLoading: false,
      isEditing: false,
      paymentTypes: [
        { id: "P", name: this.$t("payment.type.pos") },
        { id: "B", name: this.$t("payment.type.bank") },
        { id: "D", name: this.$t("payment.type.protocol") },
        { id: "V", name: this.$t("payment.type.vaucher") },
        { id: "C", name: this.$t("payment.type.cash") }
      ],
      paymentType: { id: "", name: "" },
      amount: "",
      paymentDateConfig: {
        dateFormat: "d-m-Y",
        locale: { firstDayOfWeek: 1 }
      },
      invoiceNumber: "",
      invoiceAmount: 0,
      invoiceDate: ""
    };
  },
  methods: {
    getPaymentType(type) {
      switch (type) {
        case "B":
          return this.$t("payment.type.bank");
        case "P":
          return this.$t("payment.type.pos");
        case "C":
          return this.$t("payment.type.cash");
        case "D":
          return this.$t("payment.type.protocol");
        case "V":
          return this.$t("payment.type.vaucher");
        default:
          return this.$("payment.type.other");
      }
    },
    async addPayment() {
      this.isLoading = true;
      let details = {
        date: this.date,
        paymentType: this.paymentType.id,
        amount: this.amount
      };
      return await paymentApi
        .addPayment(this.tripId, this.participantId, details)
        .then(() => {
          Object.assign(this.$data, this.$options.data.apply(this));
        })
        .then(() => {
          this.getAllPayments();
        });
    },
    isValidInfo() {
      return this.date != "" && this.paymentType.id != "" && this.amount != "";
    },
    getAllPayments() {
      this.isLoading = true;
      paymentApi
        .allPayments(this.tripId, this.participantId)
        .then(payments => {
          this.payments = payments;
          this.isLoading = false;
        })
        .catch(() => {
          this.showToast("Something went wrong");
        });
    },
    editPayment() {
      paymentApi
        .changePaymentType(
          this.tripId,
          this.participantId,
          this.paymentId,
          this.paymentType.id
        )
        .then(() => {
          return paymentApi.changePaymentAmount(
            this.tripId,
            this.participantId,
            this.paymentId,
            this.amount
          );
        })
        .then(() => {
          Object.assign(this.$data, this.$options.data.apply(this));
        })
        .then(() => {
          return this.getAllPayments(this.tripId, this.participantId);
        })
        .catch(m => {
          this.showToast(m);
        });
    },
    generateInvoice(payment) {
      this.invoiceAmount = payment.amount
      this.invoiceDate = payment.date
      this.$store.dispatch("openPopup", "invoice");
      this.$store.dispatch("setSelectedInvoiceData", {
        tripId: this.tripId,
        participantId: this.participantId,
        paymentId: payment.id
      });
       this.$refs.invoiceNumberModal.open();
    },
    prefillForEdit(payment) {
      this.isEditing = true;
      this.amount = payment.amount;
      this.$refs.paymentType.toggleSelection(
        this.paymentTypes.find(p => p.id == payment.paymentType)
      );
      this.date = payment.date;
      this.paymentId = payment.id;
    },
    toCurrency(number) {
      // if (number < 0) return formatCurrency(0, this.$i18n.locale());
      return formatCurrency(number, this.$i18n.locale());
    },
    addPaymentWithEnter: function(e) {
      console.log(e.keyCode);
      if (e.keyCode === 13) {
        saveChanges();
      }
    },
    generateInvoiceFile() {
      this.$store.dispatch("generateInvoice", this.invoiceNumber);
    },
    generateCreditPaymentFile() {
      this.$store.dispatch("generateCreditPayment", this.invoiceNumber);
    }
  }
};
</script>

<style lang="scss">
.payment-view {
  .spinner {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 9999;
    background-color: #625c5cd6;
    top: 0;
    left: 0;
  }

  .center {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modals-list {
    .btn {
      margin-right: 20px;
      margin-bottom: 25px;
    }
  }

  .icon-grid-container:hover {
    cursor: pointer;
  }

  .add-row {
    margin: 0 auto;
  }

  .total-border {
    border-top: 1px solid #555555;
  }

  .closer {
    margin-top: -2%;
  }

  .payment-info-row:hover .edit-icon::before {
    content: "\270F";
  }

  .payment-info-row:hover .invoice-icon::before {
    content: "\02758$\02758";
  }

  .ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .payment-table td {
    padding-left: 0.4rem !important;
  }
}
</style>
